import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { TableProps } from '../../../common/types/base-table.tsx';
import type { ListViewControllerData } from '../../../controllers/list-view-issues/types.tsx';
import { LoadingTable } from './loading-table/index.tsx';
import type TableType from './main.tsx';

/**
 * 1) Code split BaseTable to lower the "async-business-list" bundle size.
 * 2) Load the main bundle faster to start BE data fetching earlier.
 * 3) Prefetch BaseTable chunk in the background while the list data is loading.
 */
export const Table = lazyForPaint<typeof TableType>(
	() => import(/* webpackChunkName: "async-jwm-list-base-table" */ './main'),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: TableProps<ListViewControllerData>) => (
	<Placeholder name="base-table" fallback={<LoadingTable {...props} />}>
		<Table {...props} />
	</Placeholder>
);
